import React, {PureComponent, ChangeEvent, CSSProperties} from 'react'
import {inject, observer} from 'mobx-react'
import cxs from 'cxs/component'
import Store from 'Store'
import Theme from 'Theme'
import History from 'helpers/History'
import {T} from 'helpers/i18n'
import {Button, FieldInput, FieldType, Input} from 'elements'

interface Props {
  store?: Store
}

interface State {
  client: string
  email: string
}

@inject('store')
@observer
class UserRecovery extends PureComponent<Props, object> {
  state: State = {
    client: '',
    email: ''
  }

  handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    this.setState({[event.target.name]: event.target.value})
  }

  handleSubmit = () => {
    this.props.store!.users
      .recovery(this.state)
      .then(() => History.replace('/'))
  }

  handleCancel = () => {
    History.replace('/login')
  }

  render() {
    const {client, email} = this.state
    return (
      <Wrapper>
        <InsideWrapper>
          <StyledInput
            label={T('client')}
            name={'client'}
            value={client}
            type={FieldType.Text}
            onChange={this.handleChange}
          />
          <StyledInput
            label={T('email')}
            name={'email'}
            value={email}
            type={FieldType.Text}
            onChange={this.handleChange}
            onSubmit={this.handleSubmit}
          />
        </InsideWrapper>
        <ButtonWrapper>
          <CancelButton secondary onClick={this.handleCancel}>
            {T('cancel')}
          </CancelButton>

          <SendButton
            primary
            loading={'post@login'}
            onClick={this.handleSubmit}>
            {T('send')}
          </SendButton>
        </ButtonWrapper>
      </Wrapper>
    )
  }
}
export default UserRecovery

const Wrapper = cxs('div')({} as CSSProperties)

const InsideWrapper = cxs('div')({
  padding: Theme.size.space[4]
} as CSSProperties)

const ButtonWrapper = cxs('div')({
  borderTop: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
  marginTop: Theme.size.space[1]
} as CSSProperties)

const StyledInput = cxs(Input)({
  padding: Theme.size.space[1]
} as CSSProperties)

const CancelButton = cxs(Button)({
  width: '50%',
  borderRight: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
  padding: Theme.size.space[2]
} as CSSProperties)

const SendButton = cxs(Button)({
  width: '50%',
  padding: Theme.size.space[2]
} as CSSProperties)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Users/containers/UserRecovery.tsx